module.exports = __webpack_public_path__ + "static/media/miniwave-policie-pymes.2d0654c0.svg";